import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IMainMenuData } from 'models/mainmenu/mainmenu';
import { IMenuItemListItem, IDefinedMenuItem } from 'models/menuitem/menuitemlistitem';
import { IMenuType } from 'models/common/menutype';
import { ViewMenuTypeCommon } from 'components';
import { MenuItemType } from 'models/enums/menuitemtype';
import renderIcon from 'helpers/renderIcon';
import { IUserPreferences } from 'models/user/userpreferences';
import { manageShopLinksAdmin, manageShopLinksMember } from 'models/shop/manageshop';
import { Dispatch } from 'react-redux';
import { setActiveMenuItemId } from 'redux/modules/menuitem/menuitem';
import { IMenuItemDataAction } from 'models/menuitem/menuitem';
import { IShopCard } from 'models/shop/shopcard';

interface IProps extends React.PropsWithChildren<{}> {
	level?: number;
	mainMenuData?: IMainMenuData;
	isMagazine?: boolean;
	parent?: IMenuItemListItem['id'];
	userPreferences?: IUserPreferences;
	activeMenuItemId?: string;
	setActiveMenuItemId?: (itemId: string) => IMenuItemDataAction;
	dontCloseAfterOnMenuItemClick?: boolean;
	restrictedMode?: boolean;
	injectedItems?: any;

	/* functions props */
	t?: (key: string) => string;
	closeSelf?: () => void;
	className?: string;
}

interface IState {
	open: undefined | IMenuItemListItem['id'];
}

const MY_SALONS = 'MY_SALONS';
const MY_SHOPS = 'MY_SHOPS';

@connect(
	(state: IStore) => {
		return {
			mainMenuData: state.mainMenu,
			userPreferences: state.userPreferences,
			activeMenuItemId: state.menuItem.activeMenuItemId,
		};
	},
	(dispatch: Dispatch<IStore>) => {
		return {
			setActiveMenuItemId: (itemId: string) => dispatch(setActiveMenuItemId(itemId)),
		};
	},
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MenuRenderer extends React.Component<IProps, IState> {
	private shops: IShopCard[] = [];

	constructor(props) {
		super(props);

		this.state = {
			open: undefined,
		};

		this.renderMenuItem = this.renderMenuItem.bind(this);
		this.closeSubmenu = this.closeSubmenu.bind(this);
		this.openSubmenu = this.openSubmenu.bind(this);
	}

	public componentDidMount() {
		if (this.state.open) {
			this.shops = this.getUserShopsFromState();
			this.setState({
				open: undefined,
			});
		}
	}

	private get items() {
		return (this.props.isMagazine ? this.props.mainMenuData.magazineItems : this.props.mainMenuData.portalItems) || [];
	}
	private get menuItemType() {
		return this.props.isMagazine ? MenuItemType.Magazine : MenuItemType.Portal;
	}

	private closeTimeout: ReturnType<typeof setTimeout>;

	private closeSubmenu() {
		clearTimeout(this.closeTimeout);
		this.closeTimeout = setTimeout(() => {
			this.setState({
				open: undefined,
			});
		}, 100);
	}
	private openSubmenu(open: IMenuItemListItem['id']) {
		clearTimeout(this.closeTimeout);
		this.setState({
			open,
		});
	}

	private renderMenuItem(item: IDefinedMenuItem, isSpecialLayout: boolean, menuItemType?: MenuItemType) {
		const menuType: string = (item.pageJObject as IMenuType)?.menuType;
		const levelNum = this.props.level || 0;
		let className = item.final ? 'final' : 'with-children';
		if (this.state.open === item.id) {
			className += ' open';
		}
		if (item.bottom) {
			className += ' bottom';
		}

		return (
			<li
				key={item.id}
				className={`${className} ${
					(typeof window !== 'undefined' &&
						window.location.href.includes(this.props.activeMenuItemId) &&
						item.code === this.props.activeMenuItemId) ||
					(typeof window !== 'undefined' && window.location.href.includes('/salons') && item.code === MY_SALONS) ||
					(typeof window !== 'undefined' && window.location.href.includes('/shop/') && item.code === MY_SHOPS)
						? 'activeLink'
						: ''
				}`}
				onMouseEnter={() => {
					this.openSubmenu(item.id);
				}}
				onClick={() => {
					this.props.setActiveMenuItemId(item.code ? item.code : '');
				}}
			>
				<ViewMenuTypeCommon
					menuType={menuType}
					key={item.id}
					item={item}
					menuItemType={menuItemType ? menuItemType : this.menuItemType}
					menuLevel={this.props.level || 0}
					t={this.props.t}
					onShowNextLevelClick={() => {
						this.openSubmenu(item.id);
					}}
					onMenuItemClick={() => {
						this.openSubmenu(item.id);
					}}
				/>
				{this.state.open === item.id || levelNum >= 2
					? this.renderSubmenu(item.id, this.state.open === item.id, isSpecialLayout)
					: null}
			</li>
		);
	}
	private getUserShopsFromState() {
		const { userPreferences } = this.props;
		const shops: IShopCard[] = [];

		if (userPreferences && userPreferences.userShops?.length > 0) {
			shops.push(...userPreferences.userShops); // Get users shops from userShops (this are the shops where user is the owner)
		}

		if (userPreferences && userPreferences?.userRoles && Object.keys(userPreferences.userRoles).length > 0) {
			const userRoles = userPreferences.userRoles; // Get user shops from user roles where user is not the owner
			for (let i = 0; i < userRoles.length; i++) {
				const role = userRoles[i];
				let shopId;

				// if role.id has type office, we have ShopId saved in role.objInfo.attributes
				if (role.type == 'Office') {
					if (!role?.objInfo?.attributes?.ShopId) {
						// if office member but we have no info about the shop, do not show
						continue;
					} else {
						shopId = role.objInfo.attributes.ShopId;
					}
				} else {
					shopId = role.objId;
				}

				const existing = shops.findIndex((shop) => shop.id === shopId);
				if (existing != -1) {
					// if someone is an admin and member, role should be admin
					if (!shops[existing].role || shops[existing].role == 'Member') {
						shops[existing].role = role.role;
					}
					continue;
				}

				// if the shop does not exist and if we have info for the shop (to generate the proper links)
				if (role?.objInfo) {
					const shopInfo = role.objInfo;
					let code = role.type == 'Shop' ? shopInfo.code : shopInfo.attributes?.ShopCode;

					// remove all non-ASCII characters, special characters and spaces from ShopName to get the correct shop code
					if (!code && shopInfo?.attributes?.ShopName) {
						code = shopInfo.attributes.ShopName.replace(/[^\w\s]/gi, '')
							.replace(/[^\x00-\x7F]+/, '')
							.replace(/[`~¨!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '')
							.replace(/\s/g, '');
					}
					// PS: this applies only to shop members, because they don't get shop code with GeneralSearch api call

					shops.push({
						id: shopId,
						code: code,
						entityId: shopInfo.id,
						name: shopInfo.attributes?.ShopName || shopInfo.name || shopInfo.clob1,
						location: shopInfo.attributes?.Location,
						picture: shopInfo.picture,
						coverPicture: '',
						description: '',
						ownerId: '',
						about: '',
						email: '',
						role: role.role,
					});
				} else {
					// if there is a permission for a shop but no information was gotten from general search
					shops.push({
						id: shopId,
						code: '',
						entityId: JSON.stringify({ id: shopId, type: role.type }),
						name: '',
						location: '',
						picture: '',
						coverPicture: '',
						description: '',
						ownerId: '',
						about: '',
						email: '',
						role: role.role,
					});
				}
			}
		}
		return shops;
	}

	private get itemsToDisplay(): IDefinedMenuItem[] {
		const { parent, t } = this.props;
		if (this.shops.length === 0) {
			this.shops = this.getUserShopsFromState();
		}
		const items = this.items;
		const definedItems: IDefinedMenuItem[] = items.map((i) => ({
			...i,
			final: !items.some((ii) => ii.parentKey === i.id),
		}));

		if (parent === MY_SHOPS && this.shops?.length > 1) {
			const links: IDefinedMenuItem[] = this.shops.map((shop) => ({
				code: shop.code,
				title: shop.name,
				id: MY_SHOPS + '_' + shop.id,
				imageUrl: shop.picture,
				icon: 'open_salon',
				final: false,
				pageJObject: { menuType: c.MENU_TYPE_SHOP } as any,
			}));
			return links;
		} else if (
			// MY SHOPS
			(parent && parent.startsWith(MY_SHOPS + '_')) ||
			(parent === MY_SHOPS && this.shops?.length === 1)
		) {
			let activeShop = this.shops[0];
			let shopId = activeShop?.id;
			if (parent.startsWith(MY_SHOPS + '_')) {
				shopId = parent.substring((MY_SHOPS + '_').length);
				activeShop = this.shops.find((s) => s.id === shopId);
			}
			const shopImage = activeShop?.picture;
			const manageShopLinks = activeShop?.role === 'Admin' ? manageShopLinksAdmin : manageShopLinksMember;
			const links: IDefinedMenuItem[] = manageShopLinks
				.filter((l) => l.inHeader)
				.map((msl) => ({
					code: msl.isShopLink ? this.shops.find((x) => x.id === shopId)?.code || '' : shopId + '/' + msl.slug,
					title: t(msl.title),
					id: shopId + '_' + msl.slug,
					icon: msl.icon || 'open_salon',
					imageUrl: msl.icon ? undefined : shopImage,
					final: true,
					pageJObject: { menuType: c.MENU_TYPE_SHOP } as any,
				}));
			return links;
		} else if (parent) {
			// PORTAL PAGE
			return definedItems.filter((item) => item.parentKey === parent);
		} else {
			// ROOT
			let items = definedItems.filter((item) => !item.parentKey);
			////////////////////////////////////
			// change home title to Salons
			////////////////////////////////////
			items = items.map((x) => {
				if (x.title === 'home') {
					x.title = t('SearchShops_Title');
				}
				return x;
			});
			////////////////////////////////////
			// Fallback if Salons link was not added
			////////////////////////////////////
			if (!items.filter((x) => x.title === t('SearchShops_Title')).length) {
				items = items.concat([
					{
						id: MY_SALONS,
						title: t('SearchShops_Title'),
						final: true,
						pageJObject: { menuType: c.MENU_TYPE_PAGE } as any,
						code: MY_SALONS,
					},
				]);
			}
			////////////////////////////////////
			if (this.shops?.length) {
				items = items.concat([
					{
						id: MY_SHOPS,
						title: t('PortalHeader_MySalon'),
						code: MY_SHOPS,
						final: false,
					},
				]);
			}
			return items;
		}
	}

	private get childrenHaveChildren() {
		return this.itemsToDisplay.some((i) => !i.final);
	}

	private get isSpecialLayout() {
		return this.props.level === 1 && this.childrenHaveChildren;
	}

	private renderSubmenu(id: IProps['parent'], active: boolean, mobileOnly: boolean) {
		const { level } = this.props;
		const levelNum = level || 0;
		if (!id) {
			return null;
		}
		return (
			<MenuRenderer
				className={(active ? 'active ' : '') + (mobileOnly ? 'd-block d-lg-none' : '')}
				level={levelNum + 1}
				closeSelf={this.closeSubmenu}
				parent={id}
			/>
		);
	}

	private get menuTitle() {
		const { parent, t } = this.props;
		let title = parent ? this.items.find((i) => i.id === parent)?.title : null;

		if (this.shops.length === 0) {
			this.shops = this.getUserShopsFromState();
		}
		if (parent === MY_SHOPS) title = t('PortalHeader_MySalon'); //mysalons menu
		if (parent && (parent.startsWith(MY_SHOPS + '_') || (parent === MY_SHOPS && this.shops?.length === 1))) {
			let activeShop = this.shops[0];
			let shopId = activeShop?.id;

			if (parent.startsWith(MY_SHOPS + '_')) {
				shopId = parent.substring((MY_SHOPS + '_').length);
				activeShop = this.shops.find((s) => s.id === shopId);
			}

			title = activeShop?.name;
		}

		return title;
	}

	public render() {
		const { level, children, closeSelf, className, restrictedMode, injectedItems } = this.props;
		const levelNum = level || 0;

		const itemsToDisplay = this.itemsToDisplay;
		const isSpecialLayout = this.isSpecialLayout;
		if (!itemsToDisplay.length) {
			return null;
		}
		const title = this.menuTitle;

		const directList = (
			<div
				className={'menuRenderer menu-with-children ' + (className || '')}
				onMouseLeave={isSpecialLayout ? null : this.closeSubmenu}
			>
				{children}
				{title && closeSelf ? (
					<button className="backButton textBtn" type="button" onClick={closeSelf}>
						{renderIcon('back')}
						<span>{title}</span>
					</button>
				) : null}
				{!restrictedMode && (
					<ul
						className={
							'menu-list level-' + levelNum + (this.childrenHaveChildren ? ' children-children' : ' children-final')
						}
					>
						{itemsToDisplay.map((item) => this.renderMenuItem(item, isSpecialLayout))}
					</ul>
				)}
				{injectedItems}
			</div>
		);

		if (isSpecialLayout) {
			return (
				<div className={'menuRenderer dual-menu ' + (className || '')} onMouseLeave={this.closeSubmenu}>
					{directList}
					{this.state.open ? this.renderSubmenu(this.state.open, true, false) : null}
				</div>
			);
		}

		return directList;
	}
}

export { MenuRenderer };
